/*----------------------------------------------------------------------------
    EditAddSmoke.tsx

----------------------------------------------------------------------------*/

import React from 'react';
import '../App.css';
import { makeStyles, Text, Divider, Dialog, DialogTrigger, Button, DialogSurface, DialogBody, DialogTitle, DialogContent, Field, Input, DialogActions, Dropdown, Option, SelectionEvents, OptionOnSelectData } from
    '@fluentui/react-components';
import { InputTypes, RexInput } from '../components/RexInput';
import { FormControls } from "../model/FormControls";
import { IAppContext } from "../model/IAppContext";
import { TheAppContext } from "../model/AppContext";
import { withStyles } from '../components/withStyles';
import { Smoke } from "../model/Smoke";
import { RexDateTime } from '../Dates/RexDateTime';

export interface OnDismissDelegate
{
    (): void;
}

export interface OnSaveDelegate
{
    (newItem: Smoke): void;
}

export interface EditAddSmokeProps
{
    styles: Record<string, string>;
    isAdd: boolean;
    open?: boolean;
    onSave: OnSaveDelegate;
    onDismiss: OnDismissDelegate;
    itemEditing: Smoke;
}

export interface EditAddSmokeState
{
    itemEditing: Smoke;
    isOpen: boolean;
}

const useStyles = makeStyles(
    {
        stackHorizontal:
        {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        stackVertical:
        {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }
        //        dividerCustom: {
        //            fontSize: '14px',
        //            fontWeight: 'bold'
        //        },
        //        insetContent: {
        //            marginLeft: '.1in',
        //            marginRight: '.1in'
        //        }

    });

class EditAddSmokeWithoutStyles extends React.Component<EditAddSmokeProps, EditAddSmokeState>
{
    context!: IAppContext;
    static contextType = TheAppContext;
    m_controls: FormControls<Smoke>;

    constructor(props: EditAddSmokeProps)
    {
        super(props);
        this.state =
        {
            isOpen: this.props.open ?? false,
            itemEditing: this.props.itemEditing,
        };

        this.m_controls = new FormControls<Smoke>(
            [
                ["SmokeID", "smokeID"],
                ["UserID", "userID"],
                ["Tenant", "tenant"],
                ["Description", "description"],
                ["Date", "date"],
                ["Weather", "weather"],
                ["BuriedWood", "buriedWood"],
                ["FloatWood", "floatWood"],
                ["Charcoal", "charcoal"],
                ["SmokerPrep", "smokerPrep"],
            ]);
    }

    async componentDidMount()
    {
        this.m_controls.updateForData(this.state.itemEditing);
    }

    async componentDidUpdate(prevProps: EditAddSmokeProps, prevState: EditAddSmokeState)
    {
        if (prevProps.itemEditing != this.props.itemEditing)
        {
            this.m_controls.updateForData(this.state.itemEditing);
            this.setState(
                {
                    itemEditing: this.props.itemEditing,
                });
        }
    }

    async onCommit(formEvent: React.FormEvent)
    {
        formEvent.preventDefault(); // don't auto dismiss

        // need to query the DOM and populate the item from that to allow
        // autofill (which doesn't fire any events)
        const newItem = this.m_controls.getDataFromFormForEvent(formEvent);

        newItem.Date = RexDateTime.createFromString(newItem.Date as unknown as string);

        this.props.onSave(newItem);
    }

    handleInputChange(field: string, value: string)
    {
        const valueToUse =
            field == "Date"
                ? RexInput.fieldValueFromInputValue(InputTypes.Date, value)
                : value;

        this.setState(
            (prevState) => ({
                itemEditing:
                {
                    ...prevState.itemEditing,
                    [field]: valueToUse
                }
            }));
    }

    dismissDialog()
    {
        this.props.onDismiss();
    }

    render()
    {
        const smoke = this.state.itemEditing;
        const onChange = this.handleInputChange.bind(this);
        const dismissOpen = () => this.dismissDialog();
        const adding = this.props.isAdd;

        return (
            <Dialog modalType="modal" open={this.props.open}>
                <DialogSurface>
                    <form onSubmit={(event) => this.onCommit(event)}>
                        <DialogBody>
                            <DialogTitle>Smoke</DialogTitle>
                            <DialogContent className={this.props.styles.content}>
                                <div className={this.props.styles.stackHorizontal}>
                                    <RexInput label="Smoke ID" controls={this.m_controls} controlName="SmokeID" style={{ width: '16em' }} onChange={onChange} value={smoke.SmokeID}/>
                                    <RexInput label="Date" controls={this.m_controls} controlName="Date" style={{ width: '16em' }} onChange={onChange} value={smoke.Date} inputType={InputTypes.Date}/>
                                </div>
                                <RexInput label="Description" controls={this.m_controls} controlName="Description" style={{ width: '32em' }} onChange={onChange} value={smoke.Description}/>
                                <RexInput label="Weather" controls={this.m_controls} controlName="Weather" style={{ width: '32em' }} onChange={onChange} value={smoke.Weather}/>
                                <RexInput label="Buried Wood" controls={this.m_controls} controlName="BuriedWood" style={{ width: '32em' }} onChange={onChange} value={smoke.BuriedWood}/>
                                <RexInput label="Float Wood" controls={this.m_controls} controlName="FloatWood" style={{ width: '32em' }} onChange={onChange} value={smoke.FloatWood}/>
                                <RexInput label="Charcoal" controls={this.m_controls} controlName="Charcoal" style={{ width: '32em' }} onChange={onChange} value={smoke.Charcoal}/>
                                <RexInput label="Smoker Prep" controls={this.m_controls} controlName="SmokerPrep" style={{ width: '32em' }} onChange={onChange} value={smoke.SmokerPrep}/>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={dismissOpen} appearance="secondary">Cancel</Button>
                                <Button type="submit" appearance="primary">Save</Button>
                            </DialogActions>
                        </DialogBody>
                    </form>
                </DialogSurface>
            </Dialog>)
    }
}

export const EditAddSmoke = withStyles(useStyles, EditAddSmokeWithoutStyles);